import React from "react";
import Header from "../../../Components/Common/Header";
import "../../../asset/css/inbox.css";
import { Container, Card, Row, Col } from "react-bootstrap";
import ManageSalesPersonCard from "../../../Components/Apps/ManageSalesPersonCard";
import ManageSalesPersonNew from "./ManageSalesPersonNew";

class ManageSalesPerson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCompose: false,
      show: false,
    };
  }

  handleNewButtonClick = () => {
    this.setState({ show: true });
  };

  handleCancelNew = () => {
    this.setState({ show: false });
  };

  render() {
    return (
      <div className="container-fluid">
        {!this.state.show && (
          <Header
            headerText=""
            mainNavigate="Shop"
            currentPage="Manage Sales Person"
            childNav={this.state.isCompose ? "Compose" : ""}
          />
        )}
        <div className="row clearfix ">
          {!this.state.show && (
            <div className="container mx-2 mb-2">
              <div className="d-flex justify-content-between">
                <div>
                  <h4>Sales Person</h4>
                </div>

                <div className="d-flex">
                  <div className="">
                    {!this.state.show && (
                      <button
                        className="btn btn-primary px-2 py-2"
                        onClick={this.handleNewButtonClick}
                      >
                        + NEW
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.show ? (
            <ManageSalesPersonNew handleCancle={this.handleCancelNew} />
          ) : (
            <ManageSalesPersonCard />
          )}
        </div>
      </div>
    );
  }
}

export default ManageSalesPerson;
